import styles from './HamburgerButton.module.css';

import { cn } from '@/lib/utils';

import { IconButton } from '@/decodo/components/atoms/IconButton';

type HamburgerButtonProps = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

export function HamburgerButton({
  isOpen,
  onOpenChange,
}: HamburgerButtonProps) {
  return (
    <IconButton
      noStyles
      size='s'
      onPointerDown={() => onOpenChange(!isOpen)}
      data-state={isOpen ? 'open' : 'closed'}
      classNames={{
        root: cn(
          'text-base-dark-white p-0 group flex items-center justify-center relative after:absolute after:-inset-1',
          styles.hamburger
        ),
        inner: 'relative h-4 w-6 inline-block',
      }}
    >
      <span className={cn(``, styles.hamburgerBar)} />
    </IconButton>
  );
}
